module.exports = (require("./helpers/browser/import-polyfill")(require('./helpers/bundle-manifest').resolve("bnpcq"))).then(() => parcelRequire('l1DVf'));